import { useEffect, useState } from "react";

import { useHistory, useLocation } from "react-router-dom";
import EmployeeListItem from "../models/item.interface";
import EmployeeListState from "../models/state.interface";
import fetchContentByType from "app/umbraco/helpers/fetchContentByType";

export default (tags?: string[]): any => {
    const history = useHistory();
    const location = useLocation<EmployeeListState>();

    const initialItems = location.state?.employees;
    const [items, setItems] = useState<EmployeeListItem[]>(initialItems);

    const [viewState, setViewState] = useState<string>(initialItems?.length > 0 ? "LOADED" : "LOADING");

    useEffect(() => {
        let isComponentMounted = true;

        const fetchEmployees = async () => {
            let result: EmployeeListItem[] = [];
            const response = await fetchContentByType<EmployeeListItem[]>("employeePage", history.location.pathname);

            if (response && response.length > 0) {
                const eligibleEmployees = response.filter(x => {
                    if (tags && tags.length > 0) {
                        const itemHasMatchTag = tags.every(tag => x.tags && x.tags.includes(tag));
                        return itemHasMatchTag;
                    }
                });

                result = eligibleEmployees;
            }

            if (isComponentMounted) {
                setItems(result);

                history.replace({
                    pathname: location.pathname,
                    search: location.search,
                    hash: location.hash,
                    state: {
                        ...location.state,
                        employees: result
                    }
                });

                return result;
            }
        };

        fetchEmployees().then((result: any) => {
            if (result && result.length > 0) {
                setViewState("LOADED");
            }
            else {
                setViewState("EMPTY");
            }
        }).catch(() => {
            setViewState("ERROR");
        });

        return () => {
            isComponentMounted = false;
        };
    }, []);

    return [items, viewState];
};